// buildingService.js
import { customFetch } from "../utils/custom-fetch";

export const fetchBuildingDataService = async (id) => {
  try {
    const response = await customFetch.get(`/public/${id}`);
    return response.data;
  } catch (error) {
    console.error("Error fetching building data:", error);
    throw error;
  }
};

export const fetchOfficeNavigationDataService = async (buildingId, floorNumber) => {
  try {
    let url = `/office/${buildingId}`;
    if (floorNumber) url += `/${floorNumber}`;
    const response = await customFetch.get(url);
    return response.data;
  } catch (error) {
    console.error("Error fetching office navigation data:", error);
    throw error;
  }
};

export const fetchQRCodeService = async () => {
  try {
    const response = await customFetch.get(`/api/v1/public/connect`);
    return response.data.qrCodeUrl;
  } catch (error) {
    console.error("Error fetching QR code:", error);
    throw error;
  }
};

export const incrementSchedulesViewsPublicService = async (buildingId, scheduleCounts) => {
  try {
    // שולחים גם buildingId
    await customFetch.post("/public/increment-schedules-views", { buildingId, scheduleCounts });
  } catch (err) {
    console.error("Error in incrementSchedulesViewsPublicService:", err);
    // לא זורקים, כי לא רוצים לשבור אם נכשל העדכון
  }
};